module.exports = __webpack_public_path__ + "media/localization/french-cbd9f4b3.png";